import { CellProps } from './types';

const SubjectCell = ({ cell }: CellProps) => {
  const subject = cell.getValue();

  return (
    <div className='subject two-line-ellipsis black heading-5'>
      {subject}
    </div>
  );
};

export default SubjectCell;
